import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { generate } from 'shortid';

import { AppServices } from './../../app.services';
import { NotifyService } from './../../addon/notify.service';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

import * as Highcharts from 'highcharts';
import * as Exporting from 'highcharts/modules/exporting';
Exporting(Highcharts)

import * as _ from 'lodash';
import * as dot from 'dot-object';
import * as mathjs from 'mathjs';
import * as domtoimage from 'dom-to-image';
declare var $:any;

@Component({
	selector: 'app-contract',
	templateUrl: './contract.component.html',
	styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {
	objectKeys = Object.keys;
	filter_lead = {};
	data_lead; lead;
	filter_contract = {};
	data_contract; contract;
	filter_bill = {};
	data_bill;
	filter_prd = {};
	data_prd; data_owner;
	earn;
	data_rpt;
	sales = [];
	constructor(private router: Router, private appServices: AppServices, private notifyService: NotifyService) { }

	ngOnInit() {
		this.loadLead();
		this.loadRpt();
	}
	ngAfterViewChecked() {
		$('.text-justify img').addClass('img-fluid');
		$(document).on('focusin', function(e) {
			if ($(e.target).closest(".mce-window").length) {
				e.stopImmediatePropagation();
			}
		});
	}
	assign(frm, data) {
		$.each(data, function(key){
			frm[key] = data[key];
		})
	}
	parseJson(data, index, el) {
		try{
			data[index] = JSON.parse(el);
		} catch(e){}
	}
	parseTable(data) {
		let thead = Object.keys(data[0]).reduce((a,b) => {
			if(!a.length) {
				return `<th>${b}</th>`
			} else {
				return a+=`<th>${b}</th>`
			}
		}, '')
		let tbody = data.reduce((a,b) => {
			let content = Object.keys(b).reduce((i,k) => {
				if(!i.length) {
					return `<td>${b[k]}</td>`
				} else {
					return i += `<td>${b[k]}</td>`
				}
			}, '')
			if(!a.length) {
				return `<tr>${content}</tr>`
			} else {
				return a += `<tr>${content}</tr>`
			}
		}, '')
		return `<table><tr>${thead}</tr>${tbody}</table>`
	}
	parseTotal(data) {
		return data.reduce((a,b)=>{
			return a+=b.total
		}, 0)
	}
	goTab(el) {
		$(`a[href="${el}"]`)[0].click();
	}
	genShort(frm, attr) {
		frm[attr] = generate();
	}
	getDrive(frm) {
		if(frm['photo']) {
			frm['photo'] = 'https://drive.google.com/uc?id=' + frm['photo'].split('/')[5];
		} else {
			frm['photo'] = 'https://drive.google.com/uc?id=';
		}
	}

	loadChartFunnel(data) {
		Highcharts.chart('chartFunnel', {
			chart: {
				type: 'funnel'
			},
			title: {
				style: {
					display: 'none'
				}
			},
			plotOptions: {
				series: {
					dataLabels: {
						enabled: true,
						format: '<b>{point.name}</b> ({point.y:,.0f})',
						softConnector: true
					},
					center: ['40%', '50%'],
					neckWidth: '30%',
					neckHeight: '25%',
					width: '80%'
				}
			},
			legend: {
				enabled: false
			},
			series: [data],
			credits: {
				enabled: false
			},
		});
	}
	searchOwner(data) {
		if(data.length > 1) {
			this.loadOwner(data);
		} else {
			this.data_owner = null;
		}
	}
	loadOwner(filter = null) {
		let find = {"deleted":false, 'code': this.appServices.session[0].member.attributes.codeowner, 'or': [{'name':{'ilike': filter}},{'subname':{'ilike':filter}}]}
		this.appServices.api('Owners/find', {
			'filter': `{"where":${JSON.stringify(find)}}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			res.map(el => {
				return Object.assign(el, {'name': el.subname?el.subname+'-'+el.name:el.name })
			})
			obj.component.data_owner = res;
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadLead(param = null, add = false) {
		let filter = this.filter_lead;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "accountcode": this.appServices.accountcode})
		this.appServices.api('Crmleads/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_lead.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_lead.res = obj.component.data_lead.res.concat(json.res);
			} else {
				obj.component.data_lead = json;
			}
			if(json.res.length > 0) {
				obj.component.chooseLead(json.res[0])
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	chooseLead(data) {
		this.lead = data;
		this.loadContract({'codelead': data.code});
		this.loadBill({'codelead': data.code})
	}
	loadContract(param = null, add = false) {
		let filter = this.filter_contract;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false})
		this.appServices.api('Crmcontracts/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_contract.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_contract.res = obj.component.data_contract.res.concat(json.res);
			} else {
				obj.component.data_contract = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadBill(param = null, add = false) {
		let filter = this.filter_bill;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, "accountcode": this.appServices.accountcode})
		this.appServices.api('Crmbills/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_bill.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_bill.res = obj.component.data_bill.res.concat(json.res);
			} else {
				obj.component.data_bill = json;
			}
			let data = [[obj.component.lead.name, obj.component.lead.total]].concat(obj.component.data_bill.res.map(el => {
				return [el.name, el.amount]
			}));
			obj.component.loadChartFunnel({
				'name': obj.component.lead.name,
				'data':data
			});
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
		this.appServices.api('Crmbills/sum', {
			'filter': `{"where":${JSON.stringify(filter)}}`,
			'prop': 'codelead'
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.earn = res[0]
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadRpt() {
		this.appServices.api('Hosreports/find', {
			'filter': `{"where":{"codeorg": "${this.appServices.appname}", "deleted":false}, "order":"created_dt desc"}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.data_rpt = res;
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	loadPrd(param = null, add = false) {
		let filter = this.filter_prd;
		if(param) {
			filter = $.extend(filter, param);
			let paramIndex = Object.keys(filter).indexOf(Object.keys(param)[0]);
			if(!(Object.values(filter)[paramIndex])){
				delete filter[Object.keys(param)[0]];
			}
		}
		Object.assign(filter, {"deleted":false, 'codeowner': this.appServices.session[0].member.attributes.codeowner})
		this.appServices.api('Products/find', {
			'filter': `{"where":${JSON.stringify(filter)},"skip":${add ? this.data_prd.res.length : 0},"order":"created_dt desc"}`
		}, this).then(function(obj){
			let json = obj.response.json();
			if(add) {
				obj.component.data_prd.res = obj.component.data_prd.res.concat(json.res);
			} else {
				obj.component.data_prd = json;
			}
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	moreContact() {
		this.loadContract(this.filter_contract, true);
	}
	moreBill() {
		this.loadBill(this.filter_bill, true);
	}
	morePrd() {
		this.loadPrd(this.filter_prd, true);	
	}
	saveContract(data) {
		data = _.pickBy(data);
		data['codelead'] = this.lead.code;
		data['deleted'] = false;
		data['email'] = {
			'to': data['to'],
			'cc': data['cc']
		}
		data['info'] = {
			'contract_no': data['contract_no'] ? data['contract_no'] : '',
			'contract_dt': data['contract_dt'] ? data['contract_dt'] : '',
			'day': data['day'] ? data['day'] : '',
			'month': data['month'] ? data['month'] : '',
			'year': data['year'] ? data['year'] : '',
			'compA': data['compA'] ? data['compA'] : '',
			'addressA': data['addressA'] ? data['addressA'] : '',
			'nameA': data['nameA'] ? data['nameA'] : '',
			'mstA': data['mstA'] ? data['mstA'] : '',
			'phoneA': data['phoneA'] ? data['phoneA'] : '',
			'positionA': data['positionA'] ? data['positionA'] : '',
			'compB': data['compB'] ? data['compB'] : '',
			'addressB': data['addressB'] ? data['addressB'] : '',
			'nameB': data['nameB'] ? data['nameB'] : '',
			'mstB': data['mstB'] ? data['mstB'] : '',
			'phoneB': data['phoneB'] ? data['phoneB'] : '',
			'positionB': data['positionB'] ? data['positionB'] : '',
			'fee_setup': data['fee_setup'] ? data['fee_setup'] : '',
			'fee_remain': data['fee_remain'] ? data['fee_remain'] : '',
		}
		this.appServices.api('Crmcontracts/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.loadContract();
			obj.component.notifyService.show(obj.response.statusText)
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	saveBill(data) {
		data = _.pickBy(data);
		data['accountcode'] = this.appServices.accountcode;
		data['codelead'] = this.lead.code;
		data['deleted'] = false;
		data['email'] = {
			'to': data['to'],
			'cc': data['cc']
		}
		data = dot.object(data);
		this.appServices.api('Crmbills/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.loadBill({'codelead': obj.component.lead.data});
			obj.component.notifyService.show(obj.response.statusText)
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	parsePrint(rpt, data, frm) {
		data['updated_dt'] = data['updated_dt'].substr(0, 10)
		frm['content'] = mathjs.print(rpt.template, data)
	}
	doSend(data) {
		domtoimage.toPng(document.getElementById('print-template')).then((base64) => {
			this.appServices.api('Contacts/sendmail', {
				'to': [data.email.to],
				'cc': [data.email.cc],
				'subject': data.name,
				'content': `<img src="cid:bg">`,
				'files': [{
					"cid":"bg",
					"path": base64
				}]
			}, this).then(function(obj){
				let res = obj.response.json().res;
				obj.component.notifyService.show(obj.response.statusText)
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');
			})
		}).catch(function (err) {
			console.log(err)
		});
	}
	savePrd(data) {
		data = _.pickBy(data);
		data['codeowner'] = data.codeowner;
		data['deleted'] = false;
		data['detail'] = data['detail'] ? JSON.parse(data['detail']) : [];
		data['variant'] = data['variant'] ? JSON.parse(data['variant']) : {};
		data['attributes'] = data['attributes'] ? JSON.parse(data['attributes']) : [];
		this.appServices.api('Products/save', data, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.notifyService.show(obj.response.statusText)
			obj.component.loadPrd();
		}).catch(function(err){
			err.component.notifyService.show(err.err.json().error.message, 'danger');
		})
	}
	doSale(data, qty) {
		let find = this.sales.find(el => el.code == data.code)
		if(!find) {
			this.appServices.api('Crmcontracts/find', {
				'filter': `{"where":{"codelead":"${this.lead.code}", "subcode":"${data.codeowner}"}}`
			}, this).then(function(obj){
				let res = obj.response.json().res;
				var variant = data.variant;
				if(res.length > 0) {
					Object.assign(variant, {'price': variant.price * (1 - ((res[0].discount ? res[0].discount : 0) / 100))});
				}
				obj.component.sales.push(Object.assign({
					'code': data.code,
					'name': data.name,
					'qty': qty
				}, variant, {
					'total': variant.price * qty
				}))
				Highcharts.chart('chartPie', {
					chart: {
						type: 'pie'
					},
					title: {
						style: {
							display: 'none'
						}
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							cursor: 'pointer',
							dataLabels: {
								enabled: false
							},
							showInLegend: true
						}
					},
					series: [{
						name: 'Group',
						data: obj.component.sales.map(el => {
							return {
								name: el.name,
								y: el.price * el.qty
							}
						})
					}],
					credits: {
						enabled: false
					},
				});
			}).catch(function(err){
				err.component.notifyService.show(err.err.json().error.message, 'danger');	
			})
		} else if (find) {
			find.qty = qty;
			Highcharts.chart('chartPie', {
				chart: {
					type: 'pie'
				},
				title: {
					style: {
						display: 'none'
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: false
						},
						showInLegend: true
					}
				},
				series: [{
					name: 'Group',
					data: this.sales.map(el => {
						return {
							name: el.name,
							y: el.price * el.qty
						}
					})
				}],
				credits: {
					enabled: false
				},
			});
		}
	}
	exportSale() {
		new Angular2Csv(this.sales, (new Date()).getFullYear() + (parseInt((new Date()).getMonth().toString()) + 1) + (new Date()).getDate() +  '_' + (new Date()).getHours() + (new Date()).getMinutes() + (new Date()).getSeconds(), {
			headers: Object.keys(this.sales[0]),
			showTitle: false,
			fieldSeparator: '\t'
		})
	}
	doInvoice() {

	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/main/contract/contract.component.ts